import { Contestant, RankedContestant } from '../types/contestant';
import { supabase } from '../lib/supabase';

export const fetchContestants = async (contestId: string): Promise<Contestant[]> => {
  const response = await fetch(`/api/contests/${contestId}/contestants`);
  if (!response.ok) throw new Error('Failed to fetch contestants');
  return response.json();
};

export const fetchContestantRanking = async (contestId: string): Promise<RankedContestant[]> => {
  // Récupérer les participants avec leurs votes
  const { data: contestants, error: contestantsError } = await supabase
    .from('contestants')
    .select(`
      *,
      votes:votes(count)
    `)
    .eq('contest_id', contestId);

  if (contestantsError) throw contestantsError;

  // Trier par nombre de votes et ajouter le rang
  return (contestants || [])
    .sort((a, b) => ((b.votes?.[0]?.count || 0) - (a.votes?.[0]?.count || 0)))
    .map((contestant, index) => ({
      ...contestant,
      votes_count: contestant.votes?.[0]?.count || 0,
      rank: index + 1
    }));
};

export const fetchContestantByCode = async (code: string): Promise<Contestant> => {
  const response = await fetch(`/api/contestants/code/${code}`);
  if (!response.ok) throw new Error('Failed to fetch contestant');
  return response.json();
};

export const fetchContestantById = async (id: string): Promise<Contestant | null> => {
  if (!id) return null;
  
  const { data, error } = await supabase
    .from('contestants')
    .select(`
      id,
      name,
      photo_url,
      description,
      unique_code,
      contest_id,
      contest:contests(
        id,
        name,
        description,
        vote_price,
        status
      )
    `)
    .eq('id', id)
    .single();

  if (error) throw error;
  return data;
};